/**
 *日期yyyyMMdd转换成yyyy-MM-dd
 */
import utils from '../utils';
export default function dateConvertFilter(input) {
	if (input !== undefined) {
		let date = utils.parseDate(input);
		return utils.formatDate(date, 'yyyy-MM-dd');
	}
	return input;
}


// WEBPACK FOOTER //
// ./src/modules/filter/dateConvertFilter.js